const allocationTableStyle = {
  backgroundColor: 'common.white',
  '& .actions': {
    backgroundColor: 'unset',
  },
  '& .striped-even': {
    backgroundColor: '#f5f5f5',
  },
  '& .striped-odd': {
    backgroundColor: '#ffffff',
  },
};

export default allocationTableStyle;
